import {useEffect} from 'react'
import {useParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'

const usePostParticipantAddOn = (isHardReload = true, callback = () => {}) => {
	const {idx} = useParams()

	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [, setAlert] = useAlertModalAtom()
	const clickEvent = (participantIdx, eventIdx) => {
		let url = `/admin/event/${eventIdx ? eventIdx : idx}/participant/${participantIdx}/addon`

		fetchRequest('POST', url)
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				if (isHardReload) {
					window.location.reload()
				}
				callback()
				break
			case 400:
				if (fetchResult?.data?.error_code === 'event_idx') {
					setAlert('대회 idx 입력 양식을 확인해 주세요.')
				} else if (fetchResult?.data?.error_code === 'participant_idx') {
					setAlert('참가자 idx 입력 양식을 확인해 주세요.')
				} else if (fetchResult?.data?.message) {
					setAlert(fetchResult?.data?.message)
				} else {
					setAlert('입력한 값의 형식이 잘못되었습니다.')
				}

				break
			case 404:
				if (fetchResult?.data?.error_code === 1) {
					setAlert('대회 데이터가 존재하지 않습니다.')
				} else if (fetchResult?.data?.error_code === 2) {
					setAlert('참가자 데이터가 존재하지 않습니다.')
				} else if (fetchResult?.data?.message) {
					setAlert(fetchResult?.data?.message)
				}

				break
			case 409:
				if (fetchResult?.data?.error_code === 1) {
					setAlert('이미 에드온을 지급한 참가자 입니다.')
				} else if (fetchResult?.data?.message) {
					setAlert(fetchResult?.data?.message)
				}

				break
			default:
				break
		}
	}, [fetchResult])

	return [clickEvent, isLoading]
}

export default usePostParticipantAddOn
